function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { getUiOptions, getDefaultFormState } from "../Schema/utils";

class ImageCropdataField extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getField", () => {
      const _this$props = this.props,
            uiSchema = _this$props.uiSchema,
            defaultOptions = _this$props.defaultOptions;
      const uiOptions = getUiOptions(uiSchema);
      return _extends({}, this.props, {
        uiSchema: _extends({}, uiSchema, {
          "ui:options": _extends({}, defaultOptions, {}, uiOptions)
        })
      });
    });
  }

  render() {
    const _this$getField = this.getField(),
          registry = _this$getField.registry,
          uiSchema = _this$getField.uiSchema;

    const ObjectField = registry.fields.ObjectField;
    return React.createElement(ObjectField, _extends({}, this.props, {
      uiSchema: uiSchema
    }));
  }

}

_defineProperty(ImageCropdataField, "defaultProps", {
  defaultOptions: {
    "layout": "imageCropper"
  }
});

export default ImageCropdataField;